module.exports = __webpack_public_path__ + "static/media/maze2.e945a76d.png";